/*
 * HumanCheckModal.module.css
 * All colors use design tokens from themes.css — supports light and dark mode.
 */

.backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  position: relative;
  background-color: var(--color-bg-card);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 32px 28px 28px;
  max-width: 400px;
  width: 100%;
  margin: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
}

.closeBtn {
  position: absolute;
  top: 10px;
  right: 14px;
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: var(--color-text-muted);
  padding: 2px 6px;
}

.closeBtn:hover {
  color: var(--color-text-primary);
}

.title {
  font-size: 1.2rem;
  font-family: var(--font-family-base);
  color: var(--color-text-primary);
  margin: 0;
  text-align: center;
}

.description {
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  margin: 0;
  text-align: center;
}

.verifying {
  font-size: 0.85rem;
  color: var(--color-text-muted);
  margin: 0;
}

.errorMsg {
  font-size: 0.85rem;
  color: #c0392b;
  margin: 0;
  text-align: center;
}

[data-theme='dark'] .errorMsg {
  color: #e57373;
}
